import { render } from "./MailReceive.vue?vue&type=template&id=afd64526&scoped=true"
import script from "./MailReceive.vue?vue&type=script&lang=js"
export * from "./MailReceive.vue?vue&type=script&lang=js"

import "./MailReceive.vue?vue&type=style&index=0&id=afd64526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd64526"]])

export default __exports__